import { Theme, css } from '@emotion/react';

import React, { PropsWithChildren } from 'react';

import { Spacing } from 'chatie-design-system';

import { safeArea } from '../../styles/css';
import { OnClickProps } from '../../utils/misc';

const floatingButtonAreaCSS = css`
  position: fixed;
  right: ${Spacing.medium}px;
  bottom: 0;
  z-index: 8;
  ${safeArea('bottom', 'padding', Spacing.medium)};

  > div {
    display: flex;
    align-items: center;
  }
`;

type Props = {
  children?: React.ReactNode;
};

const FloatingButtonArea = ({ children }: Props) => {
  return (
    <div css={floatingButtonAreaCSS}>
      <div>{children}</div>
    </div>
  );
};

export default FloatingButtonArea;

const floatingButtonCSS = (color?: string) => (theme: Theme) =>
  css`
    padding: ${Spacing.small + 2}px;
    background-color: ${color ?? theme.colors.main400};
    font-size: 0;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  `;

type FloatingButtonProps = {
  color?: string;
};

export const FloatingButton = ({
  color,
  children,
  onClick,
}: PropsWithChildren<FloatingButtonProps> & OnClickProps) => {
  return (
    <button css={floatingButtonCSS(color)} onClick={onClick}>
      {children}
    </button>
  );
};
